// © 2015-2021 WDNA - All Rights Reserved

import { UserDO } from 'wdna-components';

import {
  REQUEST_USER,
  USER_INFO,
  REMOVE_USER,
  RxAction
} from './actions';

export type RxState = {
  user?: UserDO;
}

const INITIAL_STATE: RxState = { user: undefined };
const DEFAULT_ACTION: RxAction = { type: '' };

/**
 * Returns next state to update from initial state as param
 *
 * @param state init state to get next one
 * @param action action information related with the state
 * @returns next state
 */
export default function reducer(state: RxState = INITIAL_STATE, action: RxAction = DEFAULT_ACTION): RxState {
  switch (action.type) {
    case USER_INFO:
      return { user: action.data };

    case REMOVE_USER:
      return INITIAL_STATE;

    case REQUEST_USER:
      return state;

    default:
      return state;
  }
}
